"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProxy = void 0;
function isIE9_11() {
    var _a;
    // @ts-ignore
    var ua = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
    if (ua == null) {
        return false;
    }
    if (ua.indexOf('Trident/7.0') > -1) {
        return true; // 11
    }
    else if (ua.indexOf('Trident/6.0') > -1) {
        return true; // 10
    }
    else if (ua.indexOf('Trident/5.0') > -1) {
        return true; // 9
    }
    return false;
}
exports.getProxy = (function () {
    if (isIE9_11()) {
        console.log('inject proxy-polyfill for ie.');
        // @ts-ignore
        require('proxy-polyfill/proxy.min.js');
    }
    return function (raw, handlers) { return new Proxy(raw, handlers); };
})();
//# sourceMappingURL=proxy.js.map